import { ReactNode } from "react";
import { Colors, Icon } from "swing-components";

export type AccordionProps = {
  title: ReactNode;
  onClick: () => void;
  children: ReactNode;

  /** @default false */
  isOpen?: boolean;
};

export function Accordion(props: AccordionProps) {
  const { title, isOpen = false, children, onClick } = props;

  return (
    <div css={{ display: "flex", flexDirection: "column" }}>
      <div
        onClick={onClick}
        css={{
          background: Colors.white200,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "24px 16px",
          gap: "10px",
          borderBottom: `1px solid ${Colors.slate300}`,
          cursor: "pointer",
        }}
      >
        {/* Accordion Title */}
        {title}

        {/* Accordion Icon */}
        {/* TODO: Update with motion.div to animate `rotate` */}
        <div css={{ width: 24, height: 24, display: "flex", placeItems: "center" }}>
          <Icon name={isOpen ? "Chevron Up" : "Chevron Down"} />
        </div>
      </div>

      {/* Accordion Content */}
      {/* TODO: Update with motion.div to animate `maxHeight` */}
      <div
        aria-expanded={isOpen}
        css={{
          // It is important to set the overflow to `visible` when the accordion
          // is open to allow the box shadow to bleed outside the box model.
          overflow: isOpen ? "visible" : "hidden",
          transition: "all 0.35s ease-in-out",
          maxHeight: isOpen ? "" : 0,
        }}
      >
        <div css={{ padding: "24px 16px" }}>{children}</div>
      </div>
    </div>
  );
}
